function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { clsx } from 'clsx';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import { TooltipAttrs } from 'common/components/tooltip/types';
import { Entry, RowLabelTheme } from '../types';
export function RowLabel(props: {
  entry: Entry;
  hasNewUI: boolean;
  index: number;
  isPlaceholder: boolean;
  isReferencedMetrics: boolean;
  onGroupClick: () => void;
  onClick: () => void;
  reportName: string;
  rowIcon: SvgIconType;
  rowIndexToggleable: boolean;
  rowLabel: string;
  rowLabelPrefix: string;
  rowLabelTheme: RowLabelTheme;
  rowLabelPrefixIcon: SvgIconType;
}) {
  const isClickable = !props.isPlaceholder && props.rowIndexToggleable;
  const extraClass = _objectSpread(_objectSpread({}, props.reportName && {
    ["for-".concat(props.reportName)]: true,
    'is-hidden': props.entry.isHidden
  }), {}, {
    'is-referenced-metrics': props.isReferencedMetrics,
    'is-gray': props.rowLabelTheme === RowLabelTheme.Gray
  });
  return <>
      {/** optional prefixed grouped label */}
      {!!props.rowLabelPrefix && (!props.hasNewUI ? props.index === 0 : true) && <RowLabelContent icon={props.rowLabelPrefixIcon} label={props.rowLabelPrefix} onClick={isClickable && props.onGroupClick} extraClass={_objectSpread({
      'is-prefix': true
    }, extraClass)} />}
      <RowLabelContent icon={props.rowIcon} label={props.rowLabel} onClick={isClickable && !props.rowLabelPrefix && props.onClick} hasPrefix={!!props.rowLabelPrefix} extraClass={extraClass} data-sentry-element="RowLabelContent" data-sentry-source-file="row-label.tsx" />
    </>;
}
RowLabel.defaultProps = {
  rowLabelTheme: RowLabelTheme.Report
};
function RowLabelContent(props: {
  icon: SvgIconType;
  label?: string;
  onClick?: () => void;
  hasPrefix?: boolean;
  extraClass?: Record<string, boolean>;
  tooltip?: TooltipAttrs;
}) {
  const isClickable = Boolean(props.onClick);
  const slotName = !isClickable ? "selector-icon" : null;
  return <div key={"entry-label-".concat(slotName, "-").concat(props.icon)} className='mp-query-entry-label' elref='rowLabel' slot={slotName} data-sentry-component="RowLabelContent" data-sentry-source-file="row-label.tsx">
      {(props.label || props.icon) && <ButtonReact elref='rowLabelButton' theme={ButtonTheme.Tertiary} notFocusable={!props.onClick} tooltip={props.tooltip} className={clsx({
      'is-clickable': isClickable,
      'has-prefix': props.hasPrefix
    }, props.extraClass)} onClick={props.onClick}>
          {props.icon ? <SvgIconReact icon={props.icon} /> : <span>{props.label}</span>}
        </ButtonReact>}
    </div>;
}
RowLabelContent.defaultProps = {
  label: null,
  hasPrefix: false,
  tooltip: null
};